module.exports = __webpack_public_path__ + "static/power4-2-949e7e7bc068655b30d8cf161e5e3e34.png";